export default {
  path: 'patrol-service/work-orders/active',
  name: 'ActiveWorkOrders',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/WorkOrdersIndex')
}
